<template>
	<div class="reply contains">
		<div class="content-tit">
			<div class="flex-box">
				<h2>渠道</h2>
				<el-button type="primary" class="add" @click="dialogVisible1"
					>添加渠道</el-button
				>
				<el-input
					placeholder="搜索渠道名称"
					v-model="value1"
					style="margin-right: 40px"
				>
					<el-button
						slot="append"
						icon="el-icon-search"
						@click="Select"
					></el-button>
				</el-input>
				<div class="clear"></div>

				<el-dialog
					:title="TypeTrueModel"
					:visible.sync="dialogVisible"
					width="30%"
				>
					<div class="dialog">
						<div class="section">
							<span class="label">渠道名称</span>
							<div class="input_box">
								<el-input
									placeholder="请输入内容"
									class="input"
									v-model="MiniChannelEnum.Name"
								></el-input>
							</div>
							<div class="clear"></div>
						</div>

						<div class="section">
							<span class="label">场景值</span>
							<div class="input_box">
								<el-input
									placeholder="请输入内容"
									class="input"
									v-model="MiniChannelEnum.Value"
								></el-input>
							</div>
							<div class="clear"></div>
						</div>

						<div class="section">
							<span class="label">小程序地址</span>
							<div class="input_box">
								<el-input
									placeholder="请输入内容"
									class="input"
									v-model="MiniChannelEnum.url"
								></el-input>
							</div>
							<div class="clear"></div>
						</div>

						<div class="section">
							<span class="label">小程序AppId</span>
							<div class="input_box">
								<el-input
									placeholder="请输入内容"
									class="input"
									v-model="MiniChannelEnum.AppId"
								></el-input>
							</div>
							<div class="clear"></div>
						</div>

						<div class="section">
							<span class="label">状态</span>
							<div class="input_box">
								<el-radio
									v-model="MiniChannelEnum.state"
									label="1"
									>启用</el-radio
								>
								<el-radio
									v-model="MiniChannelEnum.state"
									label="0"
									>禁用</el-radio
								>
							</div>
							<div class="clear"></div>
						</div>

						<div class="section">
							<span class="label">是否自跳小程序</span>
							<div class="input_box">
								<el-radio
									v-model="MiniChannelEnum.SelfJump"
									label="1"
									>是</el-radio
								>
								<el-radio
									v-model="MiniChannelEnum.SelfJump"
									label="0"
									>否</el-radio
								>
							</div>
							<div class="clear"></div>
						</div>

						<div class="section">
							<span class="label">上传logo</span>
							<div class="input_box">
								<el-upload
									class="upload-demo"
									:action="defaultsUrl"
									:on-success="uploadHeadimg"
									:on-error="uploadHeadimgErr"
									multiple
									:limit="3"
									:show-file-list="false"
								>
									<el-button size="small" type="primary"
										>点击上传</el-button
									>
									<div slot="tip" class="el-upload__tip">
										只能上传jpg/png文件，且不超过500kb
									</div>
								</el-upload>

								<div class="preview">预览</div>
								<div class="img_box">
									<img
										style="width: 100%; height: 100%"
										:src="uploadimg.href"
									/>
								</div>
							</div>
						</div>

						<div class="section">
							<span class="label">备注</span>
							<div class="input_box">
								<el-input
									type="textarea"
									v-model="MiniChannelEnum.remark"
									class="input textarea"
									placeholder="请输入内容"
									resize="none"
									maxlength="100"
									show-word-limit
								></el-input>
							</div>

							<div class="clear"></div>
						</div>
					</div>
					<span slot="footer" class="dialog-footer">
						<el-button @click="Close">取 消</el-button>
						<el-button
							type="primary"
							@click="Add"
							v-if="TypeTrue != true"
							>确 定</el-button
						>
						<el-button
							type="primary"
							v-if="TypeTrue != false"
							@click="Update"
							>修改</el-button
						>
					</span>
				</el-dialog>
			</div>
		</div>
		<div class="content-main">
			<div class="flex-box">
				<div class="table_box">
					<el-table :data="tableData" style="width: 100%" border>
						<el-table-column
							type="selection"
							width="55"
						></el-table-column>
						<el-table-column
							prop="Name"
							label="渠道名称"
							width="200"
						></el-table-column>
						<el-table-column
							prop="Value"
							label="场景值"
							width="200"
						></el-table-column>
						<el-table-column
							prop="url"
							label="小程序链接"
							width="200"
						></el-table-column>
						<el-table-column
							prop="remark"
							label="备注"
						></el-table-column>
						<el-table-column label="logo">
							<template slot-scope="scope">
								<el-image
									style="width: 100px; height: 100px"
									:src="scope.row.logoUrl"
								></el-image>
							</template>
							<!-- <span>{{tableData.logoUrl}}11</span> -->
							<!-- <el-image
                        style="width: 100px; height: 100px"
                        :src="logoUrl"
							:fit="fit"></el-image>-->
						</el-table-column>
						<el-table-column
							prop="state"
							label="状态"
							width="200"
						></el-table-column>
						<!-- <el-table-column prop="operate" label="操作" width="200">
                  <i class="el-icon-edit" @click="UpdateShow()" style="cursor: pointer;"></i>
                  <i class="el-icon-delete" style="cursor: pointer;"></i>
						</el-table-column>-->
						<el-table-column fixed="right" label="操作" width="100">
							<template slot-scope="scope">
								<i
									class="el-icon-edit"
									@click="UpdateShow(scope.row.Id)"
									style="cursor: pointer"
									v-if="scope.row.IsSys == 1"
								></i>
								<i
									class="el-icon-delete"
									style="cursor: pointer"
									@click="Delete(scope.row.Id)"
									v-if="scope.row.IsSys == 1"
								></i>
								<!-- <el-button @click="handleClick(scope.row)" type="text" size="small">查看</el-button>
								<el-button type="text" size="small">编辑</el-button>-->
							</template>
						</el-table-column>
					</el-table>
				</div>
				<div class="pagination">
					<el-pagination
						@current-change="List"
						background
						layout="total, prev, pager, next"
						:total="SumUser"
					></el-pagination>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'channel',
	props: [],
	data() {
		return {
			uploadimg: {
				href: '../../../assets/preview.png',
				shortHref: '',
			},
			defaultsUrl: '',
			MiniChannelEnum: {
				Id: 0,
				Name: '',
				Value: '',
				remark: '',
				state: '1',
				url: '',
				AppId: '',
				SelfJump: '1',
				create_time: '2019-12-27',
				logoUrl: '',
			},
			TypeTrue: false,
			TypeTrueModel: '添加渠道',
			value1: '',
			value2: '',
			value3: '',
			tableData: [],
			dialogVisible: false,
			options: [
				{
					value: '选项1',
					label: '黄金糕',
				},
				{
					value: '选项2',
					label: '双皮奶',
				},
			],
			SumUser: 0,
		}
	},
	watch: {},
	mounted: function () {
		this.List(1)
	},
	created: function () {
		this.Total()
		// this.defaultsUrl = this.axios.defaults.baseURL + 'Upload/upload?files=2'
		this.defaultsUrl = this.axios.default.baseURL + 'Upload/uploadminiimg';
	},
	methods: {
		Total(KeyWord) {
			//初始化  客服总人数
			let $this = this
			this.axios
				.get(
					'MiniChannelEnum/total',
					{
						params: {
							Name: $this.value1,
						},
					},
					{
						headers: {
							'Content-Type': 'application/json',
						},
					}
				)
				.then(function (data) {
					$this.SumUser = data.data
				})
		},
		uploadHeadimg(response, file, fileList) {
			if (response.result) {
				this.uploadimg = response
				this.MiniChannelEnum.logoUrl = this.uploadimg.shortHref
				// console.log("图片")
				// console.log(this.uploadimg)
			}
		},
		uploadHeadimgErr(err, file, fileList) {},
		//返回用户列表
		List(PageSize, PageNum, KeyWord) {
			PageNum = 10
			let $this = this
			this.axios
				.get(
					'MiniChannelEnum/GetMiniChannels',
					{
						params: {
							pages: PageSize,
							pageNum: PageNum,
							Name: $this.value1,
						},
					},
					{
						headers: {
							'Content-Type': 'application/json',
						},
					}
				)
				.then(function (data) {
					$this.tableData = []
					data.data.forEach((element) => {
						$this.tableData.push({
							Id: element.id,
							Name: element.name,
							remark: element.remark,
							state: element.stateName,
							operate: '未处理',
							IsSys: element.isSys,
							Value: element.value,
							url: element.url,
							logoUrl: element.logoUrl,
						})
					})
				})
		},
		Select() {
			let $this = this
			$this.List(1, 10, $this.value1)
			$this.Total($this.value1)
		},
		//添加
		Add() {
			let $this = this

			var booleam = true

			if ($this.MiniChannelEnum.Name == '') {
				$this.$message.error('请输入渠道名称')
				booleam = false
				 
			}else if($this.MiniChannelEnum.Name.length>50) {
				$this.$message.error('渠道名称不能超过50字符')
				booleam = false
				 
			} else if ($this.MiniChannelEnum.Value == '') {
				$this.$message.error('请输入渠道场景值')
				booleam = false
			} else if($this.MiniChannelEnum.Value.length>30){
				$this.$message.error('渠道场景值不能超过30字符')
				booleam = false
			} else if ($this.MiniChannelEnum.remark == '') {
				$this.$message.error('请输入备注')
				booleam = false
			} else if($this.MiniChannelEnum.remark.length>=300){
				$this.$message.error('备注不能超过300字符')
				booleam = false
			}
			else if (
				$this.MiniChannelEnum.url == '' &&
				$this.MiniChannelEnum.SelfJump != '0'
			) {
				$this.$message.error('请输入小程序地址')
				booleam = false
			} else if (
				$this.MiniChannelEnum.AppId == '' &&
				$this.MiniChannelEnum.SelfJump != '0'
			) {
				$this.$message.error('请输入小程序AppId')
				booleam = false
			} else if ($this.MiniChannelEnum.logoUrl == '') {
				$this.$message.error('请上传logo')
				booleam = false
			}
			if (booleam) {
				$this.MiniChannelEnum.logoUrl = $this.uploadimg.shortHref
				if ($this.MiniChannelEnum.SelfJump == '0') {
					$this.MiniChannelEnum.SelfJump = false
				} else {
					$this.MiniChannelEnum.SelfJump = true
				}

				this.axios
					.post('MiniChannelEnum/Add', $this.MiniChannelEnum, {
						headers: {
							'Content-Type': 'application/json',
						},
					})
					.then(function (data) {
						if (data.data.message == '成功') {
							 
							$this.MiniChannelEnum.Name = ''
							$this.MiniChannelEnum.Value = ''
							$this.MiniChannelEnum.remark = ''
							$this.MiniChannelEnum.state = '1'
							$this.MiniChannelEnum.url = ''
							$this.MiniChannelEnum.AppId = ''
							$this.MiniChannelEnum.SelfJump = '1'
							$this.dialogVisible = false
							$this.MiniChannelEnum.logoUrl = ''
							$this.Total()
							$this.List(1)
						} else {
							$this.$message.error(data.data.message)
						}
					})
			}
		},
		//弹框
		UpdateShow(Id) {
			let $this = this
			$this.TypeTrueModel = '修改渠道'
			$this.dialogVisible = true
			$this.TypeTrue = true

			$this.axios
				.get(
					'MiniChannelEnum/UpdateModel',
					{
						params: { Id: Id },
					},
					{
						headers: {
							'Content-Type': 'application/json',
						},
					}
				)
				.then(function (data) {
					$this.MiniChannelEnum.Id = data.data.id
					$this.MiniChannelEnum.Name = data.data.name
					$this.MiniChannelEnum.Value = data.data.value
					$this.MiniChannelEnum.remark = data.data.remark
					$this.MiniChannelEnum.state = data.data.state
					$this.MiniChannelEnum.url = data.data.url
					$this.MiniChannelEnum.AppId = data.data.appId
					$this.MiniChannelEnum.logoUrl = data.data.logoUrl
					$this.uploadimg.href =
						$this.axios.defaults.baseURL +
						'upload/get?path=' +
						data.data.logoUrl

					if (data.data.selfJump) {
						$this.MiniChannelEnum.SelfJump = '1'
					} else {
						$this.MiniChannelEnum.SelfJump = '0'
					}

					if (data.data.state == 1) {
						$this.MiniChannelEnum.state = '1'
					} else {
						$this.MiniChannelEnum.state = '0'
					}
				})
		},
		dialogVisible1() {
			let $this = this

			$this.TypeTrueModel = '添加渠道'
			$this.dialogVisible = true
			$this.TypeTrue = false

			$this.MiniChannelEnum.Name = ''
			$this.MiniChannelEnum.Value = ''
			$this.MiniChannelEnum.remark = ''
			$this.MiniChannelEnum.state = '1'
			$this.MiniChannelEnum.url = ''
			$this.MiniChannelEnum.AppId = ''
			$this.MiniChannelEnum.SelfJump = '1'
			$this.MiniChannelEnum.logoUrl = ''
			$this.uploadimg.href = ''
		},
		//取消
		Close() {
			let $this = this
			$this.MiniChannelEnum.Name = ''
			$this.MiniChannelEnum.Value = ''
			$this.MiniChannelEnum.remark = ''
			$this.MiniChannelEnum.state = '1'
			$this.MiniChannelEnum.url = ''
			$this.MiniChannelEnum.AppId = ''
			$this.MiniChannelEnum.SelfJump = '1'
			$this.MiniChannelEnum.logoUrl = ''
			$this.uploadimg.href = ''
			$this.dialogVisible = false
		},
		//修改
		Update() {
			let $this = this
			var booleam = true
			alert($this.MiniChannelEnum.logoUrl)

			if ($this.MiniChannelEnum.Name == '') {
				$this.$message.error('请输入渠道名称')
				booleam = false
				 
			}else if($this.MiniChannelEnum.Name.length>50) {
				$this.$message.error('渠道名称不能超过50字符')
				booleam = false
				 
			} else if ($this.MiniChannelEnum.Value == '') {
				$this.$message.error('请输入渠道场景值')
				booleam = false
			} else if($this.MiniChannelEnum.Value.length>30){
				$this.$message.error('渠道场景值不能超过30字符')
				booleam = false
			} else if ($this.MiniChannelEnum.remark == '') {
				$this.$message.error('请输入备注')
				booleam = false
			} else if($this.MiniChannelEnum.remark.length>=300){
				$this.$message.error('备注不能超过300字符')
				booleam = false
			}
			else if (
				$this.MiniChannelEnum.url == '' &&
				$this.MiniChannelEnum.SelfJump != '0'
			) {
				$this.$message.error('请输入小程序地址')
				booleam = false
			} else if (
				$this.MiniChannelEnum.AppId == '' &&
				$this.MiniChannelEnum.SelfJump != '0'
			) {
				$this.$message.error('请输入小程序AppId')
				booleam = false
			} 
	 
			// if ($this.MiniChannelEnum.Name == '') {
			// 	alert('请输入渠道名称')
			// 	booleam = false
			// } else if ($this.MiniChannelEnum.Value == '') {
			// 	alert('请输入渠道场景值')
			// 	booleam = false
			// } else if ($this.MiniChannelEnum.remark == '') {
			// 	alert('请输入备注')
			// 	booleam = false
			// } else if ($this.MiniChannelEnum.url == '') {
			// 	alert('请输入小程序地址')
			// 	booleam = false
			// } else if ($this.MiniChannelEnum.AppId == '') {
			// 	alert('请输入小程序AppId')
			// 	booleam = false
			// }
			// // else if ($this.MiniChannelEnum.logoUrl == '') {
			// // 	alert('请上传logo')
			// // 	booleam = false
			// // }

			if (booleam) {
				// $this.MiniChannelEnum.logoUrl = $this.uploadimg.shortHref

				if ($this.MiniChannelEnum.SelfJump == '1') {
					$this.MiniChannelEnum.SelfJump = true
				} else {
					$this.MiniChannelEnum.SelfJump = false
				}
				this.axios
					.post('MiniChannelEnum/Update', $this.MiniChannelEnum, {
						headers: {
							'Content-Type': 'application/json',
						},
					})
					.then(function (data) {
						if (data.data.message == '成功') {
							$this.$message(data.data.message)
							$this.dialogVisible = false
							$this.MiniChannelEnum.logoUrl = ''
							$this.Total()
							$this.List(1)
						} else {
						 
							$this.$message.error(data.data.message)
						}
					})
			}
		},
		//删除
		Delete(Id) {
			let $this = this
			var mymessage = confirm('是否删除？')
			if (mymessage == true) {
				this.axios
					.get(
						'GroupJoinMiniChannel/Count',
						{
							params: { MiniChannelId: Id },
						},
						{
							headers: {
								'Content-Type': 'application/json',
							},
						}
					)
					.then(function (data) {
						if (data.data != 0) {
							$this.$message.error('分组上有渠道无法删除')
						} else {
							$this.axios
								.post('MiniChannelEnum/Delete?Id=' + Id, {
									headers: {
										'Content-Type': 'application/json',
									},
								})
								.then(function (data1) {
									if (data1.data.message == '成功') {
										$this.$message(data1.data.message)
										$this.Total()
										$this.List(1)
									} else {
										$this.$message.error(data1.data.message)
									}
								})
						}
					})
			} else if (mymessage == false) {
			}
		},
		// Close(){
		//   let $this=this;
		//   $this.dialogVisible=false;
		// }
	},
}
</script>

<style scoped>
.content-tit {
	line-height: 20px;
	display: flex;
	display: -webkit-flex;
	justify-content: space-between;
	align-items: center;
	padding-bottom: 5px;
}
.content-tit h2 {
	font-size: 20px;
	line-height: 30px;
	font-weight: normal;
	float: left;
}
.flex-box {
	width: 100%;
}
.add {
	float: right;
}
.import {
	float: right;
}
.export {
	float: right;
	margin-right: 10px;
}
.delete {
	float: right;
	margin-right: 10px;
}
.pagination {
	text-align: right;
}
.el-pagination {
	text-align: right;
	margin-top: 50px;
	display: inline-block;
}

.label {
	float: left;
	width: 120px;
	text-align: right;
	margin-right: 20px;
}
.section {
	line-height: 50px;
	margin-top: 10px;
}
.input_box {
	float: left;
	width: 60%;
}
.input_box .input {
	width: 100%;
}
.table_box {
	margin-top: 50px;
}
</style>
<style>
.reply .el-input-group {
	float: right;
	width: 320px;
}
.reply .el-textarea__inner {
	height: 100px;
	background-color: #fafafa;
}
</style>




// WEBPACK FOOTER //
// src/components/manage/setting/channel.vue